import { trackCustomHeapEvent } from '@tcc/analytics';

export function trackEvent(noun, verb, params) {
  trackCustomHeapEvent(`fieldview.weather.${noun}.${verb}`, params);
}
